import styled from 'styled-components';

export const EnvPanelContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 5px;
`;

export const EnvPanelUploadGroup = styled.div`
    display: flex;
    justify-content: center;
`;
